import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {PressNewsState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class PressNewsQuery extends QueryEntity<PressNewsState> {

  constructor(protected store: Store) {
    super(store);
  }

}
